import {get, writable} from '../library';

/**
 * @template T
 */
export class Store {
  /**
   * @param {T} initialValue
   */
  setStore(initialValue) {
    this.store = writable(initialValue);
  }

  /**
   * @return {T}
   */
  get() {
    return get(this.store);
  }

  /**
   * @param {T} value
   * @return {T}
   */
  setter(value) {
    return value;
  }

  /**
   * @param {T} value
   */
  set(value) {
    this.store.set(this.setter(value));
  }

  /**
   * @param {Function} run
   * @param {Function} [invalidate]
   * @return {Function}
   */
  subscribe(run, invalidate) {
    return this.store.subscribe(run, invalidate);
  }

  /**
   * @param {Function} updater
   */
  update(updater) {
    this.store.update((value) => this.setter(updater(value)));
  }
}
